module.exports = __webpack_public_path__ + "img/download_point.ccd0b853.png";